"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerticalNavItemMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Anchor = require("../../components/Anchor/Anchor.styles");
var _UnstyledButton = require("../../components/UnstyledButton/UnstyledButton.styles");
var _disabledCursorMixin = require("../disabledCursorMixin");
var _disabledMixin = require("../disabledMixin");
var _hoverMediaQueryMixin = require("../hoverMediaQueryMixin");
var _typographyMixin = require("../typographyMixin");
var AnchorButtonCSS = function AnchorButtonCSS(props) {
  return (0, _styledToken.default)({
    borderWidth: 'VerticalNavItem.borderWidth',
    fontColor: 'VerticalNavItem.fontColor',
    fontType: 'VerticalNavItem.fontType',
    horizontalSpacing: 'VerticalNavItem.horizontalSpacing',
    verticalSpacing: 'VerticalNavItem.verticalSpacing'
  }, function (_ref) {
    var borderWidth = _ref.borderWidth,
      fontColor = _ref.fontColor,
      fontType = _ref.fontType,
      horizontalSpacing = _ref.horizontalSpacing,
      verticalSpacing = _ref.verticalSpacing;
    return (0, _styledComponents.css)(["", " display:block;text-decoration:none;padding:", "px ", "px ", "px ", "px;&,&:focus{color:", ";}&:visited{color:", ";}", ";&:active{color:", ";}"], (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: fontType,
      fontTypeIconAlignment: false
    }, props)), verticalSpacing, horizontalSpacing, verticalSpacing, horizontalSpacing - borderWidth, fontColor, fontColor, (0, _hoverMediaQueryMixin.hoverMediaQueryMixin)("color: " + fontColor + ";"), fontColor);
  })(props);
};
var activeCSS = function activeCSS(props) {
  return (0, _styledToken.default)({
    backgroundColorActive: 'VerticalNavItem.backgroundColorActive',
    fontWeightActive: 'VerticalNavItem.fontWeightActive',
    borderColorActive: 'VerticalNavItem.borderColorActive'
  }, function (_ref2) {
    var backgroundColorActive = _ref2.backgroundColorActive,
      borderColorActive = _ref2.borderColorActive,
      fontWeightActive = _ref2.fontWeightActive;
    return (0, _styledComponents.css)(["background-color:", ";border-color:", ";", "{font-weight:", ";}", "{font-weight:", ";}"], backgroundColorActive, borderColorActive, _Anchor.StyledAnchor, fontWeightActive, _UnstyledButton.StyledUnstyledButton, fontWeightActive);
  })(props);
};

/** @class VerticalNavItemMixin */
/** @method */
var VerticalNavItemMixin = function VerticalNavItemMixin(props) {
  return (0, _styledToken.default)({
    backgroundColor: 'VerticalNavItem.backgroundColor',
    backgroundColorHover: 'VerticalNavItem.backgroundColorHover',
    borderColor: 'VerticalNavItem.borderColor',
    borderRadius: 'VerticalNavItem.borderRadius',
    borderWidth: 'VerticalNavItem.borderWidth'
  }, function (_ref3) {
    var backgroundColor = _ref3.backgroundColor,
      backgroundColorHover = _ref3.backgroundColorHover,
      borderColor = _ref3.borderColor,
      borderRadius = _ref3.borderRadius,
      borderWidth = _ref3.borderWidth;
    return (0, _styledComponents.css)(["background-color:", ";border-style:solid;border-width:0 0 0 ", "px;border-color:", ";box-sizing:border-box;cursor:pointer;display:block;width:100%;outline:none;text-align:left;border-top-right-radius:", "px;border-bottom-right-radius:", "px;&::-moz-focus-inner{border:0;}@media (hover:hover) and (pointer:fine){&:hover:not([aria-disabled='true']){background-color:", ";border-color:", ";}&[aria-disabled='true'] *{", "}}&:focus:not([aria-disabled='true']),&:active:not([aria-disabled='true']){background-color:", ";}&[aria-disabled]{", " > a{pointer-events:none;}}", "{", "}", "{width:100%;", "}&[aria-current]:not([aria-current='false']){", "}&[aria-selected='true']{", "}"], backgroundColor, borderWidth, borderColor, borderRadius, borderRadius, backgroundColorHover, borderColor, (0, _disabledCursorMixin.disabledCursorMixin)({
      disabled: true
    }), backgroundColorHover, (0, _disabledMixin.disabledMixin)(Object.assign({}, props, {
      disabled: true
    })), _Anchor.StyledAnchor, AnchorButtonCSS(props), _UnstyledButton.StyledUnstyledButton, AnchorButtonCSS(props), activeCSS(props), activeCSS(props));
  })(props);
};
exports.VerticalNavItemMixin = VerticalNavItemMixin;